<template>
  <div class="Resource">
    <div class="title htitle fs26">{{title}}</div>
    <div class="toc">
      <div class="prob" v-for="p in resources" @click="jumpTo(p.link)">
        {{p.name}}-{{p.desc}}
      </div>
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src

 export default {
   name: 'Resource',
   computed: {
     title() {
       return '学习资源'
     },
     resources() {
       return this.$store.state.resources;
     }
   },
   methods: {
     jumpTo(refName){
       window.open(refName, '_blank')
     }
   },

   components: {
   }
 }
</script>

<style scoped>
 .Resource{
   padding-bottom: 2vw;
 }
 .title{
   margin-top: 10vw;
   line-height: 3.6vw;
 }
 .title, .toc{
   width: 41.9vw;
   margin-left: auto;
   margin-right: auto;
 }
  .toc {
   margin-top: 3vw;
  }
 .toc > .prob{
   line-height: 3.6vw;
   color: blue;
   display: list-item;
   margin-left: 1em;
   font-size: 26px;
   cursor: pointer;
 }

 .full{
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-left: 3vw;
 }
 .ppp:last-child>div{
   border-bottom: none;
 }
</style>